
export enum ProductSKUTableSortProps {
    SKU = 'name',
    PRICE = 'price',
    STOCK = 'stock',
    SOLD = 'sold',
    REVENUE = 'revenue'
  }
  
  export interface ProductSKUTableSearchProps {
    status: string;
    name: string
    minPrice: string | number;
    maxPrice: string | number;
    minStock: number;
    maxStock: number;
    minSold?: number;
    maxSold?: number;
    minRevenue?: number;
    maxRevenue?: number;
    [key: string]: any;
  }
  